// extracted by mini-css-extract-plugin
export default {"link":"PN-z","disabled":"QN-z"};